import React, { Component } from "react";
import AddTitleBar from "../../components/titleBar/add_titleBar";
import InsertShipment from "../../components/createShipmentComponent/insertShipment";
import EditInsertShipment from "../../components/createShipmentComponent/editInsertShipment";
import ReadAxios from "../../components/axiosComponent/read";
import { connect } from "react-redux";
import { discardShipmentDispatcher, createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";

class CreateShipment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicleTypeMaster: [],
      shipment: [],
      routeName: "",
      routeCode: "",
    };
  }

  componentDidMount() {
    if (this.props.location.pathname == "/edit-shipment") {
      this.setState({ shipment: this.props.location.state });
      console.log('check data', this.props.location.state);
      // ReadAxios({
      //   completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.props.location.state.vendor_shipment_id}/orders`,
      // }).then((res) => {
      //   let shipment = this.props.location.state.orders;
      //   shipment = shipment = "";
      //   shipment = shipment = res.data;
      //   this.props.location.state.orders = shipment;
      //   console.log('>>edit>>', this.props.location.state.orders[0].shipment.route_code);
      //   console.log('>>editnam>>', this.props.location.state.orders[0].shipment.route_name);
      //   this.setState({
      //     shipment: this.props.location.state
      //   })
      //   console.log(this.state.shipment, this.state.routeCode);
      //   this.props.createShipment(this.state.shipment, false);
      // });
    } else {
    this.props.discardShipment();
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/shipment");
    // this.props.history.go();
  };

  render() {
    const { t } = this.props;
    // const { routeCode, routeName} = this.state;
    return (
      <React.Fragment>
        <AddTitleBar
          Title={this.props.location.pathname == "/edit-shipment" ? (t("edit_title") || "Edit Shipment") : +localStorage.getItem("customerNumber") == 503 ?  "Create Booking" : (t("create_title") || "Create Shipment")}
          LinkName="/shipment"
        />
        <div className="m-2">
          {this.props.location.pathname == "/edit-shipment" ? (
            <EditInsertShipment 
            mode={this.props.location.pathname == "/edit-shipment" ? "edit" : "create"}
            vehicleTypeMaster={this.state.vehicleTypeMaster}
            onFormSubmit={this.onFormSubmit}
            shipmentEdit={this.props.location.state}
            />
          ) : (
            <InsertShipment
            mode={this.props.location.pathname == "/edit-shipment" ? "edit" : "create"}
            vehicleTypeMaster={this.state.vehicleTypeMaster}
            onFormSubmit={this.onFormSubmit}
            shipmentEdit={this.props.location.state}
            // routeCodes={this.state.routeCode}
            // routeNames={this.state.routeName !="" ? this.state.routeName : ""}
          />
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    discardShipment: () => dispatch(discardShipmentDispatcher()),
    createShipment: (shipment) => dispatch(createShipmentDispatcher(shipment, false)),
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(translate("shipment")(CreateShipment));
